import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import * as am5 from '@amcharts/amcharts5';

am5.addLicense('CH228909170');
am5.addLicense('TL228909170');

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
